export const baseUrls = () => {
  const { hostname } = window.location;
  const isProd = hostname === 'rider.gocurb.com';
  return {
    UrlAuthManager: isProd
      ? 'https://authentication-manager.gocurb.com'
      : 'https://authentication-manager.release.gocurb.com',
    UrlWebApi: isProd ? 'https://webapi.gocurb.com' : 'https://webapi.release.gocurb.com',
    UrlMapboxGeocoding: 'https://api.mapbox.com',
  };
};

export const isProd = () => {
  const { hostname } = window.location;
  return hostname === 'rider.gocurb.com';
};
